export const CONST_URL_SEGEMENTS = {
    /*APIS THOSE CALLED DURING APPLICATION INITIATION.*/
    PUBLIC_APIS: [
        'i18n/.+',
        'companies/.+',
        'token',
        'recovery/password/lookup'
    ],

    BLOG_API: 'https://www.fitnessforce.com/blog/feed/',

    AUTH: {
        LOGIN_TOKEN: '/token',
        REFRESH_TOKEN: '/refresh',
        REVOKE_TOKEN: '/revoke',
        PASSWORD_LOOKUP: '/recovery/password/lookup',
        UNIQUE_IDENTIFIER: '/recovery/password/',
        PASSWORD_RESET: '/recovery/password/reset/'
    },

    INIT: {
        GET_LANG_INFO: '/get_info_lang',
        GET_COMPANY_INFO: '/company_info',
    },

    CLAIM: {
        GET_CLAIM_TEMPLATES: '/claim_templates',
        GET_ELIGIBEL_TEMPLATES: '/claim_templates/eligible_claim_templates'
    },

    SEARCH: {
        POST_SEARCH: '/search',
        POST_SEARCH_BY_TENANT_ID: '/tenants/{tenant_id}/search',
        POST_SEARCH_BY_COMPANY: '/companies/search',
        POST_SEARCH_BY_PROVIDER: '/tenants/{tenant_id}/search/providers/{provider_name}'
    },

    // Tenant apis
    TENANT: {
        GET_TENANT_LIST: '/tenants',
        GET_TENANTBYID: '/tenants',
        GET_TENANT_DEVICES:'/tenants/{tenantid}/devices'
    },

    STAFF: {
        GET_STAFF_LIST: '/staff',
        GET_STAFF_BYID: '/staff/{staff_id}',
        POST_CHANGE_PASSWORD: '/staff/{staff_id}/change_password',
        POST_SUSPEND: '/staff/{staff_id}/mark_as_suspend',
        POST_TERMINATE: '/staff/{staff_id}/mark_as_terminate',
        POST_CHANGEOWNER: '/staff/{staff_id}/change_owner',
        POST_CHANGEREPORTINGMANAGER: '/staff/{staff_id}/change_reporting_manager',
        POST_CHANGECENTERACCESS: '/staff/{staff_id}/change_center_access',
        POST_ACTIVE: '/staff/{staff_id}/mark_as_active',
        POST_STAFF: '/staff',
        PUT_STAFF: '/staff/{staff_id}',
        STAFF_NOTIFICATIONS: '/staff/notification_subscription'
    },
    SMS: {
        SMS_TEMPLATE_MASTER: '/sms_template_master',
        SEND_SMS: '/send_sms'
    },
    USERS: {
        GET_USER_LIST: '/userList',
        STAFFS: '/staff/'
    },

    CLIENT: {
        POST_CLIENTS: '/clients',
        POST_CLIENTS_FROM_CONTACT: '/contacts/{contact_id}/converttoprospect',
        GET_CLIENTS: '/clients',
        ADD_TO_BLACKLIST: '/add_to_blacklist',
        REMOVE_FROM_BLACKLIST: '/remove_from_blacklist',
        CHANGE_CLIENT_REP: '/change_client_rep',
        SUBSCRIPTIONS: '/subscriptions',
        SUBSCRIPTION_SINGUPS: '/subscription_signups',
        INVOICES: '/invoices',
        PAYMENTS: '/payments',
        SALES_RETURNS: '/sales_returns',
        REFUND: '/refund',
        PAYMENT_METHODS: '/payment_methods',
        PAYMENT_TIMELINE: '/payment_timeline',
        CLASS_APPT_TAGS: "/class_appt_tags",
        SERVICE_CAT: "/service_categories",
        IRREGULAR_CLIENTS: "/client_at_risk",
        INTERACTIONS: '/interactions',
        MIGRATION: '/migration_comments',
        RESET_PASSWORD: '/tenants/{tenant_id}/clients/{client_id}/reset_password',
        SESSION_INVENTORY: '/tenants/{tenant_id}/clients/{client_id}/session_inventory',
        ADD_CREDIT_BALANCE:'/tenants/{tenant_id}/clients/{client_id}/CreditBalance',
        GET_CREDIT_BALANCE:'/clients/{client_id}/CreditBalance',
        GET_CREDIT_BALANCE_BY_TENANT:'/tenants/{tenant_id}/clients/{client_id}/CreditBalance',
        GET_CREDIT_BALANCE_LIST:'/clients/{client_id}/centrewise_available_creditbalance',
        GET_CLIENT_REFERRALS:'/tenants/{tenant_id}/clients/{client_id}/referrals',
        GET_CLIENT_COUPONS:'/tenants/{tenant_id}/clients/{client_id}/get_eligible_coupons',
        GET_CLIENT_THREADS:'/tenants/{tenant_id}/threads',
        GET_CLIENT_FITNESS_DATA:'/tenant/{tenant_id}/get_sahha_health_score',
        VALIDATE_KEYFOB:'/tenant/{tenant_id}/validate_keyfob',
        DELETE_DIGITAL_KEYFOB:'/tenants/{tenant_id}/clients/{client_id}/access_pass',
    },

    SERVICETYPE: {
        GET_SERVICETYPE: '/tenants/{tenant_id}/service_categories'
    },

    EXPECTED: {
        GET_EXPECTED_LIST: '/expected'
    },

    BALANCE_OVERDUE: {
        GET_BALANCEOVERDUE_LIST: '/balanceoverdue'
    },

    BIRTHDAY: {
        GET_BIRTHDAY_LIST: '/clients/birthdays'
    },

    COLLECTION: {
        GET_COLLECTION_LIST: '/collection'
    },

    FOLLOWUP: {
        GET_FOLLOWUP_LIST: '/followup'
    },

    IRREGULARMEMBER: {
        GET_IRREGULARMEMBER_LIST: '/clients/irregular'
    },

    ONLINETRANSACTION: {
        GET_ONLINETRANSACTION_LIST: '/onlinetransaction'
    },

    RENEWALDUE: {
        GET_RENEWALDUE_LIST: '/renewaldue'
    },

    OPPORTUNITY: {
        OPPORTUNITY: '/opportunities'
    },

    OPPORTUNITYSTAGEMASTER: {
        OPPSTAGEMST: '/opp_stage_mst',

    },

    BOARDS: {
        TITLE: 'boards'
    },

    TASK: {
        GET_TASK: '/tenants/{tenant_id}/tasks',
        POST_TASK_BY_CLIENT: '/tenants/{tenant_id}/clients/tasks',
        POST_RECURRING_TASK_BY_CLIENT: '/tenants/{tenant_id}/clients/recurring_tasks',
        POST_TASK_BY_OPPORTUNITY: '/tenants/{tenant_id}/opportunities/tasks',
        POST_RECURRING_TASK_BY_OPPORTUNITY: '/tenants/{tenant_id}/opportunities/recurring_tasks',
        CREATE_CALL_OUTCOME: '/call_outcome',
        CREATE_TOUR_OUTCOME: '/tour_outcome',
        CREATE_TOUR_OUTCOME_REQUEST: '',
        CREATE_CALL_OUTCOME_REQUEST: '',
        GET_TASK_BY_CLIENT_ID: '/clients/{client_id}/tasks',
    },

    TASKOUTCOME: {
        POST_CALL_OUTCOME: '/tenants/{tenant_id}/tasks/{tsk_id}/call_outcome',
        POST_TOUR_OUTCOME: '/tenants/{tenant_id}/tasks/{tsk_id}/tour_outcome'
    },

    TASKCATEGORY: {
        GETTASKCATEGORY: '/tenants/{tenant_id}/task_catagories',
        UPDATETASKCATEGORY: '/tenants/{tenant_id}/task_catagories/{tsk_category_id}',
        MARKACTIVE: '/tenants/{tenant_id}/task_catagories/{tsk_category_id}/mark_as_active',
        MARKINACTIVE: '/tenants/{tenant_id}/task_catagories/{tsk_category_id}/mark_as_inactive',
        GETTASKCATEGORYBYID: '/tenants/{tenant_id}/task_catagories/{tsk_category_id}',
    },


    ROOM: {
        ROOM_LIST: "/tenants/{tenant_id}/rooms",
        ADD_ROOM: "/tenants/{tenant_id}/rooms"
    },

    SUBSCRIPTIONSIGNUP: {
        GET_COMPANY: '/subscription/signup/{sigup_sts_uuid}/company_details',
        GET_TENANT: '/subscription/signup/{sigup_sts_uuid}/tenants',
        GET_ORDERSUMMARY: '/subscription/signup/{sigup_sts_uuid}/get_order_summary',
        GET_ORDERDETAILS: '/open/companies/{company_uuid}/tenants/{tenant_uuid}/subscription/signup/{sigup_sts_uuid}/get_order_subscription_detail',
        GET_ORDER_SUBSCRIPTION_STATUS: '/subscription/signup/{sigup_sts_uuid}/get_order_subscription_status',
        GET_ORDERSUMMARYBILLINGOCCURENCE: '/subscription/signup/{sigup_sts_uuid}/get_order_summary_billing_occurrence',
        POST_PROCEEDTOPAYMENT: '/subscription/signup/{sigup_sts_uuid}/proceed_to_payment',
        POST_SAVETOKEN: '/subscription/signup/{sigup_sts_uuid}/save_token',
        POST_SAVEEXTERNALTRANSACTIONID: '/subscription/signup/{sigup_sts_uuid}/save_external_transaction_id',
        PUT_CLIENTINFO: '/subscription/signup/{sigup_sts_uuid}/client_info',
        GET_WAIVERS: '/open/companies/{company_uuid}/tenants/{tenant_uuid}/subscription/signup/{sigup_sts_uuid}/waivers',
        POST_WAIVERS: '/subscription/signup/{sigup_sts_uuid}/waivers',
        GET_CLIENT_MANDATORYFIELD: '/subscription/signup/{sigup_sts_uuid}/clients/mandatory_client_fields',
        GET_PAYMENTMETHODS: '/subscription/signup/{sigup_sts_uuid}/payment_methods',
        POST_OTP_TOKEN: '/subscription/signup/{sigup_sts_uuid}/payment_methods/{tokenid}/request_otp',
        GET_STAFF_AVAILABILITY_FOR_BOOKING: '/tenants/{sigup_sts_uuid}/appointments/{appointment_catagory_id}/availability',
        GET_TENANT_SETTINGS: '/tenants/{sigup_sts_uuid}/tenant_settings',
        BOOK_CONSULTATION: '/tenants/{sigup_sts_uuid}/appointments',
        GET_ELIGIBLE_ADDONS: '/open/tenants/{tenant_id}/subscription_plans/{plan_id}/eligible_addons',
        GET_APPOINTMENT_BY_UUID: '/open/companies/{company_id}/appointments/{appt_uuid}',
        GET_TOUR_BY_UUID: '/open/company/{company_id}/tour/{tour_uuid}',
        RESCHEDULE_APPOINTMENT_BY_UUID: '/open/companies/{company_id}/tenants/{tenant_id}/appointments/{appt_uuid}/reschedule_appointment',
        RESCHEDULE_TOUR_BY_UUID: '/open/company/{company_id}/tenants/{tenant_id}/tour/{tour_uuid}/reschedule_tour',
        GET_STAFF_AVAILABILITY_BY_APPOINTMENT_UUID: '/open/company/{company_id}/tenants/{tenant_id}/appointments/{appointment_catagory_id}/availability',
        GET_STAFF_AVAILABILITY_BY_TOUR_UUID: '/open/company/{company_id}/tenants/{tenant_id}/tour_availablity',
        VALIDATE_REFERRAL_CODE_BY_CODE: '/subscription/signup/{sigup_sts_uuid}/validate_code/{referral_code}',
        GET_SUBSCRIPTION_BY_UUID: '/subscriptions/{clt_subs_uuid}',
        GET_SUBSCRIPTION_INVOICES_BY_UUID: '/subscriptions/{clt_subs_uuid}/invoices',
        INITIATE_PAYMENT_METHOD_BY_UUID: '/subscriptions/{clt_subs_uuid}/initiate_update_payment_method',
        GET_INVOICE_BY_UUID: '/invoices/{invoice_uuid}',
        GENERATE_BALANCE_BY_UUID: '/invoices/{invoice_uuid}/generatebalanceuuid',
    },


    SCHEDULING: {
        APPOINTMENT: {
            GET_APPOINTMENTS: '/tenants/{tenant_id}/appointments',
            POST_APPOINTMENTS: '/tenants/{tenant_id}/appointments',
            POST_RECURRING_APPOINTMENTS: '/tenants/{tenant_id}/recurring_appt',
            GET_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}',
            PUT_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}',
            PUT_RECURRING_APPOINTMENT: '/tenants/{tenant_id}/recurring_appt/{appt_recurring_template_id}',
            SUBSTITUTE_COACH: '/tenants/{tenant_id}/appointments/{appt_id}/substitute_coach',
            SUBSTITUTE_COACH_RECURRING: '/tenants/{tenant_id}/recurring_appt/{appt_recurring_template_id}/substitute_coach',
            RESCHEDULE_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}/reschedule_appointment',
            RESCHEDULE_RECURRING_APPOINTMENT: '/tenants/{tenant_id}/recurring_appt/{appt_recurring_template_id}/reschedule_appt',
            MARK_CLIENT_CHECKEDIN: '/tenants/{tenant_id}/appointments/{appt_id}/mark_client_checkedin',
            MARK_CLIENT_NOSHOW: '/tenants/{tenant_id}/appointments/{appt_id}/mark_client_noshow',
            CANCEL_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}/cancel_appointment',
            UPDATE_APPOINTMENT_CLIENT_MEMBERSHIP: '/tenants/{tenant_id}/appointments/{appt_id}/change_client_membership',
            GET_APPOINTMENTS_CLIENT:"/tenants/{tenant_id}/clients/{client_id}/appointment_bookings",
            MARK_COMPLIMENTORY_APPOINTMENT:'/tenants/{tenant_id}/clients/{client_id}/comp_appointment/{appt_id}',
        },
        APPOINTMENT_TYPE: {
            GET_APPOINTMENT_TYPES: '/tenants/{tenant_id}/appointment_types'
        },
        APPOINTMENT_SUB_TYPE: {
            GET_APPOINTMENT_SUB_TYPES: '/tenants/{tenant_id}/appointment_types/{appt_type_id}/appt_subtypes'
        },
        CLASS_TYPE: {
            GET_CLASS_TYPES: '/tenants/{tenant_id}/class_types'
        },
        CLASS: {
            GET_CLASSES: '/tenants/{tenant_id}/classes',
            GET_CLASS: '/tenants/{tenant_id}/classes/{class_id}',
            GET_RECURRING_CLASS_TEMPLATE_ID: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}',
            GET_RECURRING_CLASS_TEMPLATE: '/tenants/{tenant_id}/recurring_classes',
            GET_RECURRING_CLASSES: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}/classes',
            POST_CLASSES: '/tenants/{tenant_id}/classes',
            POST_RECURRING_CLASSES: '/tenants/{tenant_id}/recurring_classes',
            PUT_CLASS: '/tenants/{tenant_id}/classes/{class_id}',
            PUT_RECURRING_CLASS: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}',
            SUBSTITUTE_COACH: '/tenants/{tenant_id}/classes/{class_id}/substitute_coach',
            SUBSTITUTE_COACH_RECURRING: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}/substitute_coach',
            RESCHEDULE_CLASS: '/tenants/{tenant_id}/classes/{class_id}/reschedule_class',
            RESCHEDULE_RECURRING_CLASS: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}/reschedule_class',
            CANCEL_CLASS: '/tenants/{tenant_id}/classes/{class_id}/cancel_class',
            DELETE_CLASS: '/tenants/{tenant_id}/classes/{class_id}',
            CANCEL_CLASS_RECURRING_TEMPLATE: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}/cancel_class',
            DELETE_CLASS_RECURRING_TEMPLATE: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}',
            COMPLETE_CLASS: '/tenants/{tenant_id}/classes/{class_id}/mark_as_completed',
            GET_CLASS_CLIENT:"/tenants/{tenant_id}/clients/{client_id}/class_bookings",
        },
        CLASS_BOOKING: {
            BOOK_CLIENTS_TO_CLASS: '/tenants/{tenant_id}/classes/{class_id}/book_client_to_class',
            REMOVE_CLIENTS_FROM_CLASS: '/tenants/{tenant_id}/classes/{class_id}/remove_client_from_class',
            MARK_CLIENT_NO_SHOW: '/tenants/{tenant_id}/classes/{class_id}/mark_client_noshow',
            MARK_CLIENT_CHECKEDIN: '/tenants/{tenant_id}/classes/{class_id}/mark_client_checkedin',
            UPDATE_CLASS_CLIENT_BOOKING: '/tenants/{tenant_id}/classes/{class_id}/change_client_membership',
            COMP_CLASS: '/tenants/{tenant_id}/clients/{client_id}/comp_class/{class_booking_id}',
            ADD_TRIAL_TO_CLASS: '/tenants/{tenant_id}/classes/{class_id}/add_trial_to_class',
        }
    },

    INVOICES: {
        GET_INVOICES: '/clients/{client_id}/invoices',
        GET_INVOICE_PDF: '/clients/{client_id}/invoices/{invoice_id}/pdf_invoice',
        VOID_INVOICE: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/void',
        SEND_EMAIL: '/clients/{client_id}/invoices/{invoice_id}/send_invoice_pdf',
        SALES_RETURN: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/sales_return',
        GET_INVOICE_OPEN: '/open/invoices/{uuid}/pdf_invoice',
        CHANGE_SALES_REP: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/change_invoice_sales_rep',

    },
    PAYMENTS: {
        GET_PAYMENTS: '/clients/{client_id}/payments',
        GET_PAYMENT_PDF: '/clients/{client_id}/payments/{pymt_id}/pdf_payment',
        VOID_PAYMENT: '/tenants/{tenant_id}/clients/{client_id}/payments/{pymt_id}/void',
        MAKE_PAYMENT: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/payments',
        SEND_EMAIL: '/clients/{client_id}/payments/{pymt_id}/send_payment_pdf',
        GET_PAYMENT_BY_ID: '/clients/{client_id}/payments/{pymt_id}',
    },

    OPEN_API: {
        GET_COUNTRY: '/open/countries',
        GET_STATE: '/open/countries/{countrycode}/states',
        GET_CITY: '/open/countries/{countrycode}/states/{statecode}/cities',
        GET_PLANLIST: '/tenants/{tenant_id}/online_signup/subscription_plans',
        GET_COMPANYBYID: '/open/companies/{company_id}',
        GET_COMPANY_SUBDOMAIN: '/open/companies?subdomain={subdomain}',
        GET_TENANTBYID: '/open/tenants/{tenant_id}',
        GET_MANDATORYFIELDS: '/tenants/{tenant_id}/online_signup/mandatory_client_fields',
        PATCH_UPDATECLIENT: '/tenants/{tenant_id}/online_signup/clients',
        GET_PLAN_BY_ID: '/tenants/{tenant_id}/online_signup/subscription_plans/{plan_id}',
        UPDATE_SUBSCRIPTION_SIGNUP: '/subscription/signup/{sigup_sts_uuid}',
        PATCH_UPDATE_CLIENT_UUID: '/subscription/signup/{sigup_sts_uuid}/client_info',
    },

    FREEZE: {
        GET_AVAILABLEFORFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/available_for_freeze',
        GET_FREEZEBYCLIENTID: '/tenants/{tenant_id}/clients/{client_id}/freeze',
        GET_FREEZEBYSUBSCRIPTIONID: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze',
        GET_FREEZETIMELINE: '/clients/{client_id}/subscriptions/{clt_subs_id}/payment_timeline',
        POST_CREATEFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze',
        POST_CANCELFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze/{clt_subfreeze_id}/cancel_freeze',
        POST_STOPFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze/{clt_subfreeze_id}/stop_freeze',
        PUT_UPDATEFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze/{clt_subfreeze_id}',
    },

    SUBSCRIPTION:{
        POST_CHANGE_SESSION_OWNER:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subs_id}/clt_memberships/{clt_membership_id}/change_session_owner",
        CANCEL_SUBSCRIPTION:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subs_id}/Cancel",
        ACTIVE_SUBSCRIPTION_MEMBERSHIP:"/clients/{client_id}/subscriptions/active_memberships",
        PUT_START_DATE_MEMBERSHIP:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/memberships/{client_membership_id}/change_start_date",
        PUT_END_DATE_MEMBERSHIP:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/memberships/{client_membership_id}/change_end_date",
        PUT_START_DATE_SUBSCRIPTION:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/change_start_date",
        PUT_END_DATE_SUBSCRIPTION:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/change_end_date",
        RECURRING_ACCURENCE_EXCEPTION:"/tenant/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/midcycle_addon_discount",
        ACTIVATE_SUBSCRIPTION:"/tenant/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/forcefully_mark_sub_signup_complete",
        RE_ACTIVATE_SUBSCRIPTION:"/tenant/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/reactivate",
        CHANGE_MEMBERSHIP_SESSIONS:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/memberships/{client_membership_id}/client_membership_patch",
    },
    
    CLIENT_TRIAL:{
        GET_TRIALS:"/tenants/{tenant_id}/clients/{client_id}/trials",
        GET_TRIAL:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}",
        POST_TRIAL:"/tenants/{tenant_id}/clients/{client_id}/trials",
        PUT_TRIALS:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}",
        DELETE_TRIALS:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}",
        POST_ACTIVATE_TRIALS:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}/activate",
        MARK_AS_ACTIVE:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}/mark_as_active",
        MARK_AS_IN_ACTIVE:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}/mark_as_inactive",
    },

    WIDGETS:{
        GET_WIDGETS:"/companies/widgets",
        GET_WIDGET_BY_ID:"/companies/widgets/{widget_id}",
        CREATE_WIDGET:"/companies/widgets",
        UPDATE_WIDGET:"/companies/widgets/{widget_id}",
        DELETE_WIDGET:"/companies/widgets/{widget_id}",
        ACTIVATE_WIDGET:"/companies/widgets/{widget_id}/mark_as_active",
        INACTIVATE_WIDGET:"/companies/widgets/{widget_id}/mark_as_inactive",
    }
};
